import { ClientLayerError } from 'shared/errors/clientLayerError'

/** Logged when GenericFieldConverter cannot convert a field to string. */
export class UnableToConvertFieldError extends ClientLayerError {
  static readonly className: string = 'UnableToConvertFieldError'

  constructor() {
    super('Unable to convert field')
    this.setMarkupOptions({ scope: 'root', section: null })
    this.addFingerprintSegment('unable-to-convert-field')
  }
}

/** Logged when GenericFieldConverter cannot parse a field from string. */
export class UnableToParseFieldError extends ClientLayerError {
  static readonly className: string = 'UnableToParseFieldError'

  constructor() {
    super('Unable to parse field')
    this.setMarkupOptions({ scope: 'root', section: null })
    this.addFingerprintSegment('unable-to-parse-field')
  }
}
